import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { css } from 'styled-components';
import { breakpoints } from '@chegg-ui/theme';

/**
 * A self executing function which provides a template media query and can be used to
 * wrap the media specific css into different standard media queries
 */
export var getMediaQuery = function () {
  var media = {};
  Object.keys(breakpoints).forEach(function (breakpoint) {
    media[breakpoint] = function (literals) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return css(["@media (max-width:", ") and (min-width:", "){", ";}"], breakpoints[breakpoint].max, breakpoints[breakpoint].min, css.apply(void 0, [literals].concat(args)));
    };
  });
  return media;
}();
/**
 * Generic type to mark some attributes(U) in type(T) as required
 */

export var gridTemplateAreas = function gridTemplateAreas(templateAreasShorthandOrTemplateString) {
  var templateAreasShorthand = typeof templateAreasShorthandOrTemplateString === 'string' ? templateAreasShorthandOrTemplateString : templateAreasShorthandOrTemplateString[0];
  return templateAreasShorthand.trim().split('\n').map(function (row) {
    return row.trim().split(' ').map(function (templateArea) {
      var _templateArea$split = templateArea.split('/'),
          _templateArea$split2 = _slicedToArray(_templateArea$split, 2),
          area = _templateArea$split2[0],
          _templateArea$split2$ = _templateArea$split2[1],
          repeat = _templateArea$split2$ === void 0 ? 1 : _templateArea$split2$;

      return new Array(+repeat).fill(area).join(' ');
    }).join(' ');
  });
};
/**
 * reusable function to get the text direction
 */

var TEXT_DIRECTION = {
  'Right to left': 'rtl',
  'Left to right': 'ltr'
};
export var getTextDirection = function getTextDirection(_ref) {
  var _ref$textDirection = _ref.textDirection,
      textDirection = _ref$textDirection === void 0 ? 'Left to right' : _ref$textDirection;
  return TEXT_DIRECTION[textDirection];
};